import { render, staticRenderFns } from "./MetricsRVSimulator.vue?vue&type=template&id=3f96bdbc&scoped=true&"
import script from "./MetricsRVSimulator.vue?vue&type=script&lang=js&"
export * from "./MetricsRVSimulator.vue?vue&type=script&lang=js&"
import style0 from "./MetricsRVSimulator.vue?vue&type=style&index=0&id=3f96bdbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96bdbc",
  null
  
)

export default component.exports